<template lang='pug'>
//- Ecard-Page
div(:class='$style[`cc-ecard`]')
  div(v-if='!isPreloading' :class='$style[`cc-ecard-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 我的
        span.font-doctor-theme 病
        span.font-normal-theme 歷
        //- span.no-wrap 資料

      //- 大頭照
      button(
        v-if='loginProfile.user_type === `doctor`'
        tabindex='0'
        aria-label='上傳頭像'
        :class='$style[`cc-banner-avatar`]'
        @click='showAvatarUploader')
        div(:class='$style[`cc-avatar-upload`]')
          IconCamera(:size='14' :color='`#fff`')
          span 上傳頭像

        figure(v-if='loginProfile.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
          //- Doctor-Male-Avatar
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
            width='100%'
            height='100%')
          //- Doctor-Female-Avatar
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')


      //- 大頭照
      button(
        v-else-if='loginProfile.user_type === `normal` && loginProfile.account_login === `cancell`'
        tabindex='0'
        aria-label='上傳頭像'
        :class='$style[`cc-banner-avatar`]'
        @click='showAvatarUploader')
        div(:class='$style[`cc-avatar-upload`]')
          IconCamera(:size='14' :color='`#fff`')
          span 上傳頭像

        figure(v-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')


      //- 大頭照
      div(
        v-else-if='loginProfile.user_type === `normal` && loginProfile.account_login !== `cancell`'
        :class='$style[`cc-banner-avatar`]')
        figure(v-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')


      div(v-if='loginProfile.user_type === `doctor`' :class='$style[`cc-avatar-name`]')
        span.font-bold.font-doctor-theme {{ avatarShowName }}
        //- span.font-bold!= '醫師'

      div(v-else :class='$style[`cc-avatar-name`]')
        span.font-bold.font-normal-theme(v-if='loginProfile.public === `yes`') {{ avatarShowName }}
        span.font-bold.font-normal-theme(v-else) {{ loginProfile.gender === `0` ? `${loginProfile.firstName}先生` : `${loginProfile.firstName}小姐` }}
        span.font-bold 會員

      //- div(v-else :class='$style[`cc-avatar-name`]')
        //- span.font-bold!= '無效的會員'

    div(v-if='loginProfile.user_type === `normal`' :class='$style[`cc-ecard-menu`]')
      div(:class='$style[`cc-ecard-menu-wrap`]')

        router-link(
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-menu-nav`]'
          :active-class='$style[`js-selected`]'
          to='/ecard')
          IconData(:size='21' :color='`#262626`')
          span 病歷資料

        router-link(
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-menu-nav`]'
          :active-class='$style[`js-selected`]'
          to='/setting')
          IconSetting(:size='21' :color='`#262626`')
          span 帳戶設定



    //- 個人資料清單
    div(:class='[$style[`cc-ecard-wrap`], $style[`edit-mode`]]')
      header.font-medium(:class='$style[`cc-ecard-title`]') 建議根據病況，定時更新
        span(:class='$style[`cc-ecard-title-tips`]') 為必填

      div(:class='$style[`cc-ecard-form`]')
        //- 帳號認證
        //- div(:class='$style[`cc-ecard-form-list`]')
        //-   div(:class='$style[`cc-ecard-form-list-title`]')
        //-     span 帳號認證
        //-   div(v-if='loginProfile.verified === `yes`' :class='$style[`cc-ecard-form-loader`]')
        //-     div(title='已認證會員' :class='[$style[`cc-ecard-verify`], $style[`cc-is-verify`]]')
        //-       div(:class='$style[`cc-ecard-verify-icon`]')
        //-         IconConfirm(:size='16' :color='`#fff`')
        //-       span 已認證
        //-   div(v-else :class='$style[`cc-ecard-form-loader`]')
        //-     div(title='未認證會員' :class='$style[`cc-ecard-verify`]')
        //-       div(:class='$style[`cc-ecard-verify-icon`]')
        //-         IconConfirm(:size='16' :color='`#fff`')
        //-       span 未認證


        //- 已訂閱服務
        //- div(:class='[$style[`cc-ecard-form-list`],$style[`align-top`]]')
        //-   div(:class='$style[`cc-ecard-form-list-title`]')
        //-     span!= '訂閱方案'
        //-   div(v-if='!loginSubscribeValid.length' :class='$style[`cc-ecard-form-loader`]')
        //-     span.font-medium 免費方案
        //-   div(v-else :class='$style[`cc-ecard-form-loader`]')
        //-     ul(:class='$style[`cc-ecard-subscribe-ul`]')
        //-       li(v-for='(items, index) in loginSubscribeValid' :class='$style[`cc-ecard-subscribe-li`]')
        //-         div(:class='$style[`cc-ecard-subscribe-li-top`]')
        //-           div(:class='$style[`cc-ecard-subscribe-li-top-name`]')
        //-             span {{ transferSubscribeServiceName(items.ItemName) }}
        //-           div(:class='$style[`cc-ecard-subscribe-li-top-due`]')
        //-             span.font-medium {{ `${items.dueTime}到期` }}
                //- div(:class='$style[`cc-ecard-subscribe-li-bottom`]')
                //-   span.font-medium 服務範圍：放化療副作用照護 / 癌症營養飲食
                //-   span.font-medium 醫師團隊：
                //-     router-link(to='/team/1') 癌康網:Dr.廖の營養輔助醫學
        

        //- 罹患癌症
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 病患關係
          div(:class='$style[`cc-ecard-form-area`]')
            SelectModel(
              v-model='formConfig.role'
              title='請選擇身份'
              style='width: 210px'
              :class='$style[`cc-select-area`]'
              :placehold='`身份別`'
              :optionList='[`我是照顧者`, `病患本人`]'
              :errorValue='formVerify.roleError'
              :defaultValue='formConfig.role'
              @clearErrorMsg="(value) => {this.formVerify.role = value}")


        //- 身高
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 身高(Cm)
          div(:class='$style[`cc-ecard-form-area`]')
            Inputer(
              v-model.trim='formConfig.height'
              title='請填寫身高'
              style='width: 100px'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`168`'
              :defaultValue='formConfig.height'
              :errorValue='formVerify.heightError'
              :errorRegex='formVerify.heightRegexError'
              :errorRegexInfo='formVerify.heightErrorLog'
              @clearErrorMsg="(value) => {this.formVerify.heightError = value[0]; this.formVerify.heightRegexError = value[1];}")
    

        //- 體重
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 體重(Kg)
          div(:class='$style[`cc-ecard-form-area`]')
            Inputer(
              v-model='formConfig.weight'
              title='請填寫體重'
              style='width: 100px'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`65`'
              :defaultValue='formConfig.weight'
              :errorValue='formVerify.weightError'
              :errorRegex='formVerify.weightRegexError'
              :errorRegexInfo='formVerify.weightErrorLog'
              @clearErrorMsg="(value) => {this.formVerify.weightError = value[0]; this.formVerify.weightRegexError = value[1];}")


        //- 出生日期
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 出生日期   

          div(:class='$style[`cc-ecard-form-area`]')
            date-picker(
              v-model='formConfig.dateBirth'
              placeholder='選擇日期'
              valueType='format'
              format='YYYY.MM.DD'
              :default-value='formConfig.dateBirth'
              @pick='dateBirthKillError'
              :class='[`date-picker`, $style[formVerify.dateBirthError ? `cc-datepicker-error` : ``]]')
              template(v-slot:header="{ emit }")
                button(
                  v-for='(items, index) in datePickerYearShortCut'
                  :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                  class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}


        //- 聯絡手機
        //- div(:class='$style[`cc-ecard-form-list`]')
        //-   div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
        //-     span!= '聯絡手機'

        //-   div(:class='$style[`cc-ecard-form-area`]')
        //-     Inputer(
        //-       v-model.trim='formConfig.phone'
        //-       title='請填寫手機'
        //-       style='width: 210px'
        //-       :class='$style[`cc-input-area`]'
        //-       :resetButton='false'
        //-       :placehold='`0912345678`'
        //-       :defaultValue='formConfig.phone'
        //-       :errorValue='formVerify.phoneError'
        //-       :errorRegex='formVerify.phoneRegexError'
        //-       :errorRegexInfo='formVerify.phoneErrorLog'
        //-       @clearErrorMsg="(value) => {this.formVerify.phoneError = value[0]; this.formVerify.phoneRegexError = value[1];}")


        //- 罹患癌症
        div(:class='[$style[`cc-ecard-form-list`], $style[`align-top`]]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 罹患癌症
          div(:class='$style[`cc-ecard-form-area`]')
            Inputer(
              v-model='formConfig.cancertype'
              title='請選擇罹患癌症'
              style='width: 210px;'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`範例：肺腺癌`'
              :defaultValue='formConfig.cancertype'
              :errorValue='formVerify.cancertypeError'
              @clearErrorMsg="(value) => {this.formVerify.cancertypeError = value[0];}")
            //- SelectModel(
            //-   v-model='formConfig.cancertype'
            //-   title='請選擇罹患癌症'
            //-   style='width: 210px'
            //-   :class='$style[`cc-select-area`]'
            //-   :placehold='`癌症別`'
            //-   :defaultValue='formConfig.cancertype'
            //-   :optionList='CANCER_TYPE'
            //-   :errorValue='formVerify.cancertypeError'
            //-   @clearErrorMsg="(value) => {this.formVerify.cancertypeError = value}")

            //- Inputer(
            //-   v-if='formConfig.cancertype === `填寫其他`'
            //-   v-model='formConfig.cancertypeSpecial'
            //-   title='某某癌'
            //-   style='width: 210px; margin-left: 10px'
            //-   :class='$style[`cc-input-area`]'
            //-   :resetButton='false'
            //-   :placehold='`某某癌`'
            //-   :defaultValue='formConfig.cancertypeSpecial'
            //-   :errorValue='formVerify.cancertypeSpecialError'
            //-   @clearErrorMsg="(value) => {this.formVerify.cancertypeSpecialError = value[0];}")

        
        //- 癌症期數
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 癌症期數
          div(:class='$style[`cc-ecard-form-area`]')
            SelectModel(
              v-model='formConfig.cancerlevel'
              title='請選擇癌症期數'
              style='width: 210px'
              :class='$style[`cc-select-area`]'
              :placehold='`期數`'
              :optionList='[`原位癌`, `一`, `二`, `三`, `四`]'
              :defaultValue='formConfig.cancerlevel'
              :errorValue='formVerify.cancerlevelError'
              @clearErrorMsg="(value) => {this.formVerify.cancerlevelError = value}")


        //- 初次診斷
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 初次診斷
          div(:class='$style[`cc-ecard-form-area`]')
            date-picker(
              v-model='formConfig.dateFirstDiagnose'
              placeholder='選擇日期'
              valueType='format'
              format='YYYY.MM.DD'
              @pick='dateFirstDiagnoseKillError'
              :default-value='formConfig.dateFirstDiagnose'
              :class='[`date-picker`, $style[formVerify.dateFirstDiagnoseError ? `cc-datepicker-error` : ``]]')
              template(v-slot:header="{ emit }")
                button(
                  v-for='(items, index) in datePickerMonthShortCut'
                  :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                  class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}


        //- 疾病狀態
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 疾病狀態
          div(:class='$style[`cc-ecard-form-area`]')
            SelectModel(
              v-model='formConfig.nowstatus'
              title='請選擇目前疾病狀態'
              style='width: 210px'
              :class='$style[`cc-select-area`]'
              :placehold='`目前狀態`'
              :optionList='[`新診斷確診`, `復發轉移`]'
              :defaultValue='formConfig.nowstatus'
              :errorValue='formVerify.nowstatusError'
              @clearErrorMsg="(value) => {this.formVerify.nowstatusError = value}")


        //- 治療醫院
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 治療醫院

          div(:class='$style[`cc-ecard-form-area`]')
            Inputer(
              v-model='formConfig.hospital'
              title='治療醫院'
              style='width: 300px'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`長庚醫院台北院區`'
              :defaultValue='formConfig.hospital'
              :errorValue='formVerify.hospitalError'
              @clearErrorMsg="(value) => {this.formVerify.hospitalError = value[0];}")


        //- 目前治療藥物名
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='[$style[`cc-ecard-form-list-title`], $style[`need-fill`]]')
            span 目前治療藥物名
          div(:class='$style[`cc-ecard-form-area`]')
            Inputer(
              v-model='formConfig.medicine'
              title='目前治療藥物名'
              style='width: 300px'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`接受治療的藥物名`'
              :defaultValue='formConfig.medicine'
              :errorValue='formVerify.medicineError'
              @clearErrorMsg="(value) => {this.formVerify.medicineError = value[0];}")


        //- 已做過治療/日期
        div(:class='[$style[`cc-ecard-form-list`], $style[`align-top`]]')
          div(:class='$style[`cc-ecard-form-list-title`]' )
            span 已做過治療/日期

          div(:class='[$style[`cc-ecard-form-area`], $style[`cc-ecard-form-area-beforeTreatment`]]')
            nav(v-for='items, index in formConfig.beforeTreatment' :key='index' :class='$style[`cc-ecard-form-area-block`]')
              SelectModel(
                v-model='formConfig.beforeTreatment[index].type'
                title='請選擇曾做過的治療'
                style='width: 100px; margin-right: 10px; margin-bottom: 5px;'
                :class='$style[`cc-select-area`]'
                :placehold='`請選擇`'
                :defaultValue='formConfig.beforeTreatment[index].type'
                :optionList='cancerTreatmentList')
              date-picker(
                v-model='formConfig.beforeTreatment[index].date'
                class='date-picker'
                placeholder='選擇日期'
                valueType='format'
                style='margin-bottom: 5px;'
                :default-value='formConfig.beforeTreatment[index].date'
                format='YYYY.MM.DD')
                template(v-slot:header="{ emit }")
                  button(
                    v-for='(items, index) in datePickerMonthShortCut'
                    :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                    class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}

              button(
                title='刪除'
                tabindex='0' aria-label='刪除'
                :class='$style[`cc-multi-form-reset`]'
                @click='multiFormResetClick(index)')
                IconClose(:size='16' :color='`#98A1A1`')
                != '刪除'

            div(:class='$style[`cc-ecard-form-area-btn`]' @click='appendNewTreatment') + 新增其他


        //- 目前做的治療
        div(:class='$style[`cc-ecard-form-list`]')
          div(:class='$style[`cc-ecard-form-list-title`]')
            span 目前做的治療

          div(:class='$style[`cc-ecard-form-area`]')
            SelectModel(
              v-model='formConfig.nowTreatment'
              title='請選擇目前做的治療'
              style='width: 100px; margin-right: 10px;'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :defaultValue='formConfig.nowTreatment'
              :optionList='cancerTreatmentList')


        //- 其他疾病
        div(:class='[$style[`cc-ecard-form-list`], $style[`align-top`], $style[`expand`]]')
          div(:class='$style[`cc-ecard-form-list-title`]')
            span 其他疾病

          div(:class='$style[`cc-ecard-form-area`]')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`糖尿病`'
              :defaultChecked='checkFeatureInclude(`糖尿病`)'
              @sendCheckStatus='watchCheckBoxUpdate')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`高血壓`'
              :defaultChecked='checkFeatureInclude(`高血壓`)'
              @sendCheckStatus='watchCheckBoxUpdate')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`腎臟病`'
              :defaultChecked='checkFeatureInclude(`腎臟病`)'
              @sendCheckStatus='watchCheckBoxUpdate')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`肝硬化`'
              :defaultChecked='checkFeatureInclude(`肝硬化`)'
              @sendCheckStatus='watchCheckBoxUpdate')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`中風`'
              :defaultChecked='checkFeatureInclude(`中風`)'
              @sendCheckStatus='watchCheckBoxUpdate')
            CheckBox2(
              style='margin: 5px 18px 5px 0px;'
              :labelText='`心臟病`'
              :defaultChecked='checkFeatureInclude(`心臟病`)'
              @sendCheckStatus='watchCheckBoxUpdate')


      div(:class='$style[`cc-ecard-controller`]')
        button(
          tabindex='0'
          aria-label='立即更新'
          :class='[$style[`cc-controller-button`], $style[`cc-controller-update`], `bg-normal-theme`]'
          @click='handleCheckProgressBeforeCreate') 立即更新

  


  div(v-if='isPreloading' :class='$style[`cc-preloader-content`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 我的
        span.font-doctor-theme 病
        span.font-normal-theme 歷
        //- span.no-wrap 資料

    div(:class='$style[`cc-preloader-banner`]')
      div.skeleton-preload(:class='$style[`cc-preloader-avatar`]')
      div(:class='$style[`cc-preloader-title`]')
        div.skeleton-preload(:class='$style[`cc-preloader-name`]')
        div.skeleton-preload(:class='$style[`cc-preloader-sub-title`]')


</template>

<script>
// import axios from 'axios';
import { mapGetters, mapActions, mapMutations } from 'vuex';
// import GlobalEmitter from 'tiny-emitter/instance';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/zh-tw';

import Inputer from '../common/Input';
import SelectModel from '../common/SelectModel';
import CheckBox2 from '../common/Checkbox2';
import Switcher from '../common/Switcher';

import IconClose from '../../icon/Close';
import IconConfirm from '../../icon/Confirm';
import IconLoading from '../../icon/Loading';
import IconCamera from '../../icon/Camera';
import IconData from '../../icon/Data';
import IconSetting from '../../icon/Setting';

import {
  getCurrentDate,
  // getSendVerifiedMail,
  putUpdateSideEffectProfile,
  getLoadSideEffectProfile,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '我的病歷資料',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/ecard',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/ecard',
      }],
    };
  },

  components: {
    IconConfirm,
    IconCamera,
    IconClose,
    IconLoading,
    IconData,
    IconSetting,

    DatePicker,
    Inputer,
    SelectModel,
    CheckBox2,
    Switcher,
  },

  data() {
    return {
      isPreloading: true,
      personal_id: '',
      avatarShowName: '',

      formConfig: {
        role: '',
        height: '',
        weight: '',
        phone: '',
        cancertype: '',
        cancertypeSpecial: '',
        cancerlevel: '',
        nowstatus: '',
        hospital: '',
        medicine: '',
        dateBirth: '',
        dateFirstDiagnose: '',
        beforeTreatment: [],
        nowTreatment: '',
        otherdiseaseText: '',
        otherdisease: [],
      },

      formVerify: {
        roleError: false,

        heightError: false,
        heightRegexError: false,
        heightErrorLog: '限3位數字',

        weightError: false,
        weightRegexError: false,
        weightErrorLog: '限3位數字',

        phoneError: false,
        phoneRegexError: false,
        phoneErrorLog: '格式錯誤',

        cancertypeError: false,
        cancertypeSpecialError: false,
        cancerlevelError: false,
        nowstatusError: false,
        hospitalError: false,
        medicineError: false,
        dateBirthError: false,
        dateFirstDiagnoseError: false,
      },

      verifyAllPass: true,
      nextTick: 1,
    };
  },

  created() {
    if (!this.loginStatus) {
      this.$router.push({
        name: 'index',
      }).catch(() => true);
    } else {
      this.axiosLoadSideEffectProfile();
      this.avatarShowName = `${this.loginProfile.firstName}${this.loginProfile.lastName}`;
    }
  },

  // mounted() {
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
      // changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    ...mapActions({
      changeLoginStatus: 'user/userLoginMember',
      changeUserPanel: 'user/changeTopBarUserPanelFocus',
    }),

    showAvatarUploader() {
      this.changePopBoxStatus({
        active: true,
        include: 'avatarUpload',
      });
    },

    checkFeatureInclude(feature) {
      return this.formConfig.otherdisease.includes(feature);
    },

    appendNewTreatment() {
      this.formConfig.beforeTreatment.push({type: '', date: ''});
    },

    multiFormResetClick(index) {
      this.formConfig.beforeTreatment.splice(index, 1);
    },

    splitOtherTreatmentStr(stringToSplit, separator) {
      // const arrayOfStrings = stringToSplit.split(separator);
      this.formConfig.otherdiseaseText = stringToSplit;
      const newArray = stringToSplit ? stringToSplit.split(separator) : []
      console.log('splitOtherTreatmentStr', newArray);
      return newArray;
    },

    watchCheckBoxUpdate(value, text) {
      if (value === 'checked') {
        this.formConfig.otherdisease.push(text);
      } else {
        const filterArray = this.formConfig.otherdisease.filter((e) => e !== text);
        this.formConfig.otherdisease = filterArray;
      }
      // this.filterConfig.feature = JSON.stringify(this.featureChoose).replace(/\[|]/g, '').replace(/["']/g, '');
      console.log('this.formConfig.otherdisease', this.formConfig.otherdisease);
    },

    dateBirthKillError() {
      this.formVerify.dateBirthError = false;
    },

    dateFirstDiagnoseKillError() {
      this.formVerify.dateFirstDiagnoseError = false;
    },

    axiosLoadSideEffectProfile() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      getLoadSideEffectProfile('', {
        aid: `${this.loginDjangoId}`
      }, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
        .then((res) => {
          console.log('讀取副作用基本資料 Success', res);
          this.personal_id = res.data.personal_id;
          this.formConfig.role = res.data.role;
          this.formConfig.height = res.data.height;
          this.formConfig.weight = res.data.weight;
          this.formConfig.phone = res.data.phone;
          this.formConfig.cancertype = res.data.cancertype;
          this.formConfig.cancertypeSpecial = res.data.cancertype;
          this.formConfig.cancerlevel = res.data.cancerperiod;
          this.formConfig.nowstatus = res.data.nowstatus;
          this.formConfig.hospital = res.data.hospital;
          this.formConfig.medicine = res.data.medicine;
          this.formConfig.dateBirth = res.data.birthday;
          this.formConfig.dateFirstDiagnose = res.data.firstdiagnose;
          this.formConfig.beforeTreatment = JSON.parse(res.data.beforetreatment);
          this.formConfig.nowTreatment = res.data.nowtreatment;
          this.formConfig.otherdisease = this.splitOtherTreatmentStr(res.data.otherdisease, ',');
          this.formConfig.otherdiseaseText = res.data.otherdisease;

          this.isPreloading = false;
        })
        .catch((err) => {
          console.log('讀取副作用基本資料 Error', err);
        })
    },

    analyzeBeforeTreatmentEmpty(arr) {
      let newArr = [];
      arr.map((x) => {
        if (x.type) {
          newArr.push(x);
        }
      });
      return JSON.stringify(newArr);
    },

    axiosCreateSideEffectProfile() {
      if (!this.verifyAllPass) { return; }

       getCurrentDate('')
        .then((res) => {
          // const jwtAccess = JSON.parse(this.authJwtToken).a;
          const CONFIG = {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          };

          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            phone: `${this.formConfig.phone}`,
            birthday: `${this.formConfig.dateBirth}`,
            pr_role: `${this.formConfig.role}`,
            pr_height: `${this.formConfig.height}`,
            pr_weight: `${this.formConfig.weight}`,
            pr_cancertype: this.formConfig.cancertype === `填寫其他` ? `${this.formConfig.cancertypeSpecial}` : `${this.formConfig.cancertype}`,
            pr_cancerperiod: `${this.formConfig.cancerlevel}`,
            // pr_subtype: "",
            pr_firstdiagnose: `${this.formConfig.dateFirstDiagnose}`,
            pr_nowstatus: `${this.formConfig.nowstatus}`,
            pr_hospital: `${this.formConfig.hospital}`,
            pr_medicine: `${this.formConfig.medicine}`,
            pr_beforetreatment: this.analyzeBeforeTreatmentEmpty(this.formConfig.beforeTreatment),
            pr_nowtreatment: `${this.formConfig.nowTreatment}`,
            pr_otherdisease: `${this.formConfig.otherdisease}`,
            pr_lastdate: `${res.data}`,
          };

          console.log('POST_DATA', POST_DATA);

          putUpdateSideEffectProfile(`?pid=${this.personal_id}`, POST_DATA, CONFIG)
            .then((res) => {
              console.log('更新副作用基本資料 Success', res);
              this.changePopBoxStatus({
                active: true,
                include: 'updateConfirm',
              });

              this.nextTick += 1;

              setTimeout(() => {
                // this.showLoading = false;
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, this.POP_DURATION);
            })
            .catch((err) => {
              console.log('更新副作用基本資料 Error', err);
            })
            
        })
        .catch((err) => {
          console.log('getCurrentDate Error', err);
        })
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;
      // 姓氏與姓名不是中文
      // const chinesePattern = new RegExp(/[\u4e00-\u9fa5]$/);
      const heightWeightPattern = new RegExp(/^[0-9]{2,3}$/);
      // const phonePattern = new RegExp(/^09\d{8}$/);
      // 驗證角色欄位為空
      if (!this.formConfig.role) {
        this.formVerify.roleError = true;
        this.verifyAllPass = false;
      }

      // 驗證身高欄位為空
      if (this.formConfig.height) {
        if (!this.formConfig.height.match(heightWeightPattern)) {
          this.formVerify.heightError = true;
          this.formVerify.heightRegexError = true;
          this.verifyAllPass = false;
        }
      } else {
        this.formVerify.heightError = true;
        this.verifyAllPass = false;
      }

      // 驗證體重欄位為空
      if (this.formConfig.weight) {
        if (!this.formConfig.weight.match(heightWeightPattern)) {
          this.formVerify.weightError = true;
          this.formVerify.weightRegexError = true;
          this.verifyAllPass = false;
        }
      } else {
        this.formVerify.weightError = true;
        this.verifyAllPass = false;
      }

      // 驗證生日欄位為空
      if (!this.formConfig.dateBirth) {
       this.formVerify.dateBirthError = true;
        this.verifyAllPass = false;
      }

      // 驗證手機欄位為空
      // if (this.formConfig.phone) {
      //   if (!this.formConfig.phone.match(phonePattern)) {
      //     this.formVerify.phoneError = true;
      //     this.formVerify.phoneRegexError = true;
      //     this.verifyAllPass = false;
      //   }
      // } else {
      //   this.formVerify.phoneError = true;
      //   this.verifyAllPass = false;
      // }

      // 驗證癌症別欄位為空
      if (!this.formConfig.cancertype) {
        this.formVerify.cancertypeError = true;
        this.verifyAllPass = false;
      } else if (this.formConfig.cancertype === '填寫其他') {
        if (!this.formConfig.cancertypeSpecial) {
          this.formVerify.cancertypeSpecialError = true;
          this.verifyAllPass = false;
        }
      }

      // 驗證癌症期數欄位為空
      if (!this.formConfig.cancerlevel) {
       this.formVerify.cancerlevelError = true;
        this.verifyAllPass = false;
      }

      // 驗證初次診斷欄位為空
      if (!this.formConfig.dateFirstDiagnose) {
       this.formVerify.dateFirstDiagnoseError = true;
        this.verifyAllPass = false;
      }

      // 驗證目前狀態欄位為空
      if (!this.formConfig.nowstatus) {
       this.formVerify.nowstatusError = true;
        this.verifyAllPass = false;
      }

      // 驗證治療醫院欄位為空
      if (!this.formConfig.hospital) {
       this.formVerify.hospitalError = true;
        this.verifyAllPass = false;
      }

       // 驗證治療藥物欄位為空
       if (!this.formConfig.medicine) {
       this.formVerify.medicineError = true;
        this.verifyAllPass = false;
      }
    },

    async handleCheckProgressBeforeCreate() {
      await this.handleFormsCheckToPass();
      await this.axiosCreateSideEffectProfile();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // forceUpdateKey: 'global/exportForceUpdateKey',
      subscribeVip: 'user/exportUserSubscribeVip',
      loginSubscribeValid: 'user/exportUserSubscribeValid',
    }),
  },

  watch: {
    'accountProfile.account': function (val) {
      if (val !== this.loginProfile.oauth) {
        this.isAccountChange = true;
      }
    },
  }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/account/ecard.scss';
</style>
